import { ShopRowData } from "../../../types";
import { SCAN_TO_DEFAULT_MAIN_COLOR } from "../shared/constants";

export type PropsType = {
    rowData?: ShopRowData;
};

export type LanguageOption = {
    code: string;
    label: string;
};

export type RestaurantText = {
    name: string;
    description: string;
};

// Re-exported from shared/constants so the brand color lives in a single
// place; existing imports of DEFAULT_PRIMARY_COLOR keep working.
export const DEFAULT_PRIMARY_COLOR = SCAN_TO_DEFAULT_MAIN_COLOR;
export const DEFAULT_SECONDARY_COLOR = "#333333";

export const LANGUAGES: LanguageOption[] = [
    { code: "fr", label: "Français" },
    { code: "en", label: "Anglais" },
    { code: "ru", label: "Russe" },
    { code: "it", label: "Italien" },
    { code: "es", label: "Espagnol" },
    { code: "pt", label: "Portugais" },
    { code: "de", label: "Allemand" },
    { code: "ar", label: "Arabic" },
];

export const DEFAULT_RESTAURANT_TEXTS: Record<string, RestaurantText> = {
    fr: {
        name: "Restaurant",
        description:
            "Nous proposons des aliments de haute qualité et le meilleur service de livraison, ainsi qu'un marché alimentaire sur lequel vous pouvez compter aveuglément.",
    },
    en: {
        name: "Restaurant",
        description:
            "We offer high quality food and the best delivery service, as well as a food market you can rely on blindly.",
    },
    ru: {
        name: "Ресторан",
        description:
            "Мы предлагаем высококачественную еду и лучший сервис доставки, а также продовольственный рынок, на который вы можете положиться.",
    },
    it: {
        name: "Ristorante",
        description:
            "Offriamo cibo di alta qualità e il miglior servizio di consegna, oltre a un mercato alimentare su cui potete contare ciecamente.",
    },
    es: {
        name: "Restaurante",
        description:
            "Ofrecemos alimentos de alta calidad y el mejor servicio de entrega, así como un mercado de alimentos en el que puede confiar ciegamente.",
    },
    pt: {
        name: "Restaurante",
        description:
            "Oferecemos alimentos de alta qualidade e o melhor serviço de entrega, bem como um mercado alimentar no qual pode confiar cegamente.",
    },
    de: {
        name: "Restaurant",
        description:
            "Wir bieten hochwertige Lebensmittel und den besten Lieferservice sowie einen Lebensmittelmarkt, auf den Sie blind vertrauen können.",
    },
    ar: {
        name: "مطعم",
        description:
            "نحن نقدم طعاماً عالي الجودة وأفضل خدمة توصيل، بالإضافة إلى سوق غذائي يمكنك الاعتماد عليه بثقة تامة.",
    },
};
